var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail01Purple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.33301 4.66602L6.77629 8.47631C7.21707 8.78486 7.43746 8.93913 7.67718 8.99889C7.88894 9.05167 8.11041 9.05167 8.32217 8.99889C8.56189 8.93913 8.78228 8.78486 9.22306 8.47631L14.6663 4.66602M4.53301 13.3327H11.4663C12.5864 13.3327 13.1465 13.3327 13.5743 13.1147C13.9506 12.9229 14.2566 12.617 14.4484 12.2407C14.6663 11.8128 14.6663 11.2528 14.6663 10.1327V5.86602C14.6663 4.74591 14.6663 4.18586 14.4484 3.75803C14.2566 3.38171 13.9506 3.07575 13.5743 2.884C13.1465 2.66602 12.5864 2.66602 11.4663 2.66602H4.53301C3.4129 2.66602 2.85285 2.66602 2.42503 2.884C2.0487 3.07575 1.74274 3.38171 1.55099 3.75803C1.33301 4.18586 1.33301 4.74591 1.33301 5.86602V10.1327C1.33301 11.2528 1.33301 11.8128 1.55099 12.2407C1.74274 12.617 2.0487 12.9229 2.42503 13.1147C2.85285 13.3327 3.4129 13.3327 4.53301 13.3327Z",
    stroke: "#A459FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01Purple);
export default __webpack_public_path__ + "static/media/mail-01-purple.e16fee7202035fe8d811e72fec4eea5d.svg";
export { ForwardRef as ReactComponent };